import React from 'react'

import { NavLink, NavLinkProps } from 'react-router-dom'

const FwdRefNavLink = React.forwardRef<HTMLAnchorElement, NavLinkProps>(function Link(props, ref) {
  return (
    <NavLink
      innerRef={ref}
      {...props}
    />
  )
})

export default FwdRefNavLink
